import { Injectable } from '@angular/core';
import {
  FilterQuery,
  OrderFilter,
  OrderFilters,
} from 'graphql-api/baskets-api-interfaces';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AbstractReadOnlyDataProvider } from '@epicuro-next/data-providers/base-data-provider';

import { FilterAccountsGQL } from '../../queries/order-book-filter-accounts.gql';
import { FilterYearGQL } from '../../queries/order-book-filter-year.gql';
import { FiltersGQL } from '../../queries/order-book-filters.gql';

@Injectable()
export class FiltersService
  implements AbstractReadOnlyDataProvider<OrderFilters>
{
  constructor(
    private filtersGQL: FiltersGQL,
    private filterYearGQL: FilterYearGQL,
    private filterAccountsGQL: FilterAccountsGQL,
  ) {}

  public getFilters(query: FilterQuery): Observable<OrderFilters> {
    return this.filtersGQL
      .fetch({
        query,
      })
      .pipe(
        take(1),
        map((queryResult) => (queryResult.data.filters as OrderFilters) ?? []),
      );
  }

  public getFilterYears(): Observable<OrderFilter[]> {
    return this.filterYearGQL.fetch().pipe(
      take(1),
      map(
        (queryResult) => (queryResult.data.filterYear as OrderFilter[]) ?? [],
      ),
    );
  }

  public getFilterAccounts(query: FilterQuery): Observable<OrderFilter[]> {
    return this.filterAccountsGQL
      .fetch({
        query,
      })
      .pipe(
        take(1),
        map(
          (queryResult) =>
            (queryResult.data.filterAccounts as OrderFilter[]) ?? [],
        ),
        map((items) => {
          return items.map((item) => {
            return {
              ...item,
              values: item.values?.map((value) => ({
                ...value,
                count: undefined,
              })),
            };
          });
        }),
      );
  }

  public read<OrderFilters>(query: FilterQuery): Observable<OrderFilters> {
    return this.getFilters(query) as Observable<OrderFilters>;
  }
}
